export default "__VITE_ASSET__vQD8kDIN__"